import { getRepositoryEndpoint } from "./getRepositoryEndpoint.js";
import { getRepositoryEndpoint as getRepositoryEndpoint2 } from "./getRepositoryEndpoint.js";
import { getRepositoryName } from "./getRepositoryName.js";
import { getGraphQLEndpoint } from "./getGraphQLEndpoint.js";
import { isRepositoryName } from "./isRepositoryName.js";
import { isRepositoryEndpoint } from "./isRepositoryEndpoint.js";
import { buildQueryURL } from "./buildQueryURL.js";
import { Client, createClient } from "./client.js";
import { predicate } from "./predicate.js";
import { predicate as predicate2 } from "./predicate.js";
import { PrismicError } from "./PrismicError.js";
import { ForbiddenError } from "./ForbiddenError.js";
import { ParsingError } from "./ParsingError.js";
import { NotFoundError } from "./NotFoundError.js";
import * as cookie from "./cookie.js";
const getEndpoint = getRepositoryEndpoint;
const predicates = predicate;
const Predicates = predicate;
export { Client, ForbiddenError, NotFoundError, ParsingError, Predicates, PrismicError, buildQueryURL, cookie, createClient, getEndpoint, getGraphQLEndpoint, getRepositoryEndpoint2 as getRepositoryEndpoint, getRepositoryName, isRepositoryEndpoint, isRepositoryName, predicate2 as predicate, predicates };